import { createSelector } from 'reselect';
import { selectPropertyGeolocation } from 'flux/selectors/property.selectors';
import { selectCurrentStoreGeolocation } from 'flux/selectors/stores.selectors';
import { selectRouterGeolocation } from 'flux/selectors/router.selectors';
import { selectDefaultGeolocation } from 'flux/selectors/application.selectors';
import { truncateToThreeDecimals } from './../../utils/coordinatesUtils';

export const selectUserGeolocation = (state) => state.user.geolocation;
export const selectUserId = (state) => state.user.id;
export const selectUserSessionId = (state) => state.user.sessionId;

export const selectCustomGeolocation = (state) =>
  createSelector(
    [selectCurrentStoreGeolocation, selectUserGeolocation, selectRouterGeolocation],
    (currentStoreGeolocation, userGeolocation, routerGeolocation) =>
      currentStoreGeolocation || userGeolocation || routerGeolocation,
  )(state);

export const selectNearbyGeolocation = (state) =>
  createSelector(
    [selectCustomGeolocation, selectPropertyGeolocation, selectDefaultGeolocation],
    (customGeolocation, propertyGeolocation, defaultGeolocation) => {
      let location = customGeolocation || propertyGeolocation || defaultGeolocation;
      if (location) {
        const locationTruncate = { ...location };

        try {
          locationTruncate.lat = truncateToThreeDecimals(locationTruncate.lat);
          locationTruncate.lng = truncateToThreeDecimals(locationTruncate.lng);
          location = locationTruncate;
        } catch (error) {
          console.error(error);
        }
      }
      return location;
    },
  )(state);
